import { DialogContent, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import { DatePicker } from "../../../utils/form";
import moment from "moment";
import _ from "lodash";
import { useApi } from "../../../utils/hooks";
import CustomDialog from "../../../utils/CustomDialog";
import { useNavigate } from "react-router-dom";
import { Alert } from "../../../utils";

const Repeater = ({ medicalDocument: { id, type }, onClose, repeaterOpen, backPath }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [shared, setShared] = useState(false);
  const form = useForm({ defaultValues: { date: "" } });
  const { handleSubmit } = form;
  const typeName = type == "prescription" ? "receta" : "orden";
  const api = useApi();

  const onRepeat = (repeatOptions) => {
    setLoading(true);
    api
      .repeat(`${type}s`, id, repeatOptions)
      .then((response) => {
        setShared(true);
        navigate(`/details-document/${response.id}`, {
          state: { reload: true, backPath },
        });
        onClose();
      })
      .tap(() => setLoading(false));
  };

  return (
    <>
      <CustomDialog
        open={repeaterOpen}
        onClose={onClose}
        title={`Repetir ${typeName} ${id}`}
      >
        <form onSubmit={handleSubmit(onRepeat)} autoComplete="off">
          <DialogContent>
            <Stack py="1rem" px="2rem">
              <DatePicker
                form={form}
                name="date"
                label="Nueva fecha"
                required
                minDate={moment()}
              />
            </Stack>
            <Stack p="1rem" spacing="1rem">
              <LoadingButton
                variant="contained"
                type="submit"
                loading={loading}
                disabled={shared}
              >
                Generar {typeName}
              </LoadingButton>
            </Stack>
          </DialogContent>
        </form>
      </CustomDialog>
      <Alert
        severity="success"
        message={`¡${
          typeName.charAt(0).toUpperCase() + typeName.slice(1)
        } generada con éxito!`}
        onClose={() => setShared(false)}
        show={shared}
      />
    </>
  );
};

export default Repeater;
